module.exports = __webpack_public_path__ + "denys_grellmann--fe842d8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/candidatos/denys_grellmann.jpg
// module id = 159
// module chunks = 0